import React, { useState } from 'react';
import { format } from 'date-fns';
import { Icon } from '@iconify/react';

const AttackTypeDetailsTable = ({ attackTypes }) => {
  const [expandedType, setExpandedType] = useState(null);

  // Format timestamp to readable date and time
  const formatTimestamp = (timestamp) => {
    return format(new Date(timestamp), 'MM/dd/yyyy');
  };

  // Handle row click to expand/collapse details
  const handleRowClick = (type) => {
    if (expandedType === type) {
      setExpandedType(null); // Collapse if already expanded
    } else {
      setExpandedType(type); // Expand this type
    }
  };

  return (
    <div>
      <table className="min-w-full">
        <thead>
          <tr>
            <th className="text-left pb-2 text-base xl:text-lg">Attack Type</th>
            <th className="text-right pb-2 text-base xl:text-lg">Count</th>
            <th className="w-10">{/* Column for expand/collapse icon */}</th>
          </tr>
        </thead>
        <tbody>
          {attackTypes.map((item, index) => (
            <React.Fragment key={index}>
              <tr 
                className={`border-t border-bgAccent hover:bg-bgAccent text-font-secondary cursor-pointer transition-colors ${expandedType === item.type ? 'bg-bgAccent' : ''}`}
                onClick={() => handleRowClick(item.type)}
              >
                <td className="py-2">{item.type}</td>
                <td className="text-right py-2 font-semibold text-font-primary">{item.count}</td>
                <td className="text-center">
                  <Icon 
                    icon={expandedType === item.type ? "mdi:chevron-up" : "mdi:chevron-down"} 
                    className="text-primary"
                  />
                </td>
              </tr>
              
              {/* Details section that expands when clicked */}
              {expandedType === item.type && item.details && item.details.length > 0 && (
                <tr className="">
                  <td colSpan={3} className="py-2 md:px-4">
                    <div className="max-h-[300px] overflow-y-auto">
                      <table className="w-full table-fixed border-collapse">
                        <colgroup>
                          <col style={{ width: '25%' }} /> {/* Date & Time */}
                          <col style={{ width: '37.5%' }} /> {/* Attack Pattern */}
                          <col style={{ width: '37.5%' }} /> {/* Rule ID */}
                        </colgroup>
                        <thead>
                          <tr className="bg-bgAccent/30">
                            <th className="text-left py-2 px-3 text-xs">Date & Time</th>
                            <th className="text-left py-2 px-3 text-xs">Attack Pattern</th>
                            <th className="text-left py-2 px-3 text-xs">Rule ID</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.details.map((detail, detailIndex) => (
                            <tr 
                              key={detailIndex} 
                              className="border-t border-bgAccent hover:bg-bgAccent cursor-pointer text-font-secondary"
                            >
                              <td className="py-2 px-3 align-top">{formatTimestamp(detail.timestamp)}</td>
                              <td className="py-2 px-3 break-words align-top">{detail.message}</td>
                              <td className="py-2 px-3 font-mono break-words align-top">{detail.ruleId}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </td>
                </tr>
              )}
              
              {/* Show message if no details available */}
              {expandedType === item.type && (!item.details || item.details.length === 0) && (
                <tr className="bg-bgAccent/10">
                  <td colSpan={3} className="py-4 text-center text-font-secondary">
                    No detailed information available for this attack type.
                  </td>
                </tr>
              )}
            </React.Fragment>
          ))}
          
          {/* Show message if no attack types */}
          {attackTypes.length === 0 && (
            <tr className="border-t border-bgAccent">
              <td 
                colSpan={3} 
                className="text-center py-4 text-font-secondary"
              >
                No attack types to display
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AttackTypeDetailsTable;